var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBatteryEmpty(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 96 96",
    style: {
      enableBackground: "new 0 0 96 96"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M60.27,26.182h-4.75v-3.33c0-1.104-0.896-2-2-2H42.481c-1.104,0-2,0.896-2,2v3.33h-4.75c-1.104,0-2,0.896-2,2v44.965 c0,1.104,0.896,2,2,2H60.27c1.104,0,2-0.896,2-2V28.182C62.27,27.078,61.374,26.182,60.27,26.182z M44.481,24.853h7.039v1.33 h-7.039V24.853z M42.481,30.182H53.52h4.75v31.205H37.731V30.182H42.481z M37.731,71.147v-5.761H58.27v5.761H37.731z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBatteryEmpty);
export default __webpack_public_path__ + "static/media/battery-empty.62138d788bace22a1ebc69ca937e0dbc.svg";
export { ForwardRef as ReactComponent };